import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  const authToken = getToken() || store.getters.token
  if (authToken) {
    config.headers['Authorization'] = authToken
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为0是成功 可结合自己业务进行修改
  */
    const res = response.data
    if (res.code !== 0 && res.code !== 200) {
      const errorMessage = res.message || '请求失败'
      Message({
        message: errorMessage,
        type: 'error',
        duration: 3 * 1000
      })

      // 401:未登录;
      if (res.code === 401) {
        if (store.getters.openEmbedMode) {
          Message({
            message: '商城管理后台登录态无效，请返回合作方系统重新进入',
            type: 'error',
            duration: 5 * 1000
          })
          try {
            window.parent.postMessage({
              type: 'mall-open-embed-token-expired',
              message: res.message || '暂未登录或token已经过期'
            }, '*')
          } catch (e) {
            /* ignore */
          }
        } else {
          MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            store.dispatch('FedLogOut').then(() => {
              location.reload()// 为了重新实例化vue-router对象 避免bug
            })
          })
        }
      }
      
      // 创建一个标准的错误对象
      const error = new Error(errorMessage)
      error.code = res.code
      error.data = res
      return Promise.reject(error)
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)// for debug
    let errorMessage = '网络请求失败'

    if (error.response) {
      const status = error.response.status
      const data = error.response.data
      // 后端常以 HTTP 400/401/403/500 返回 JSON：{ code, message, data }，与 200 时 body 结构一致，应展示 message（如「密码不正确！」）
      if (data != null && typeof data === 'object' && typeof data.message === 'string' && data.message.trim()) {
        errorMessage = data.message.trim()
      } else if (status === 404) {
        errorMessage = '请求的资源不存在 (404)'
      } else if (status === 500) {
        errorMessage = '服务器内部错误 (500)'
      } else if (status === 403) {
        errorMessage = '权限不足 (403)'
      } else {
        errorMessage = `请求失败 (${status})`
      }
    } else if (error.request) {
      // 请求已发出但没有收到响应
      errorMessage = '服务器无响应'
    } else {
      // 其他错误
      errorMessage = error.message || '未知错误'
    }
    
    Message({
      message: errorMessage,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js